import { cn } from '@/ui/utils'
import { useEffect } from 'react'
import type { ComponentPropsWithoutRef } from 'react'
import Animated, {
	useAnimatedStyle,
	useSharedValue,
	withRepeat,
	withSequence,
	withTiming,
} from 'react-native-reanimated'

type SkeletonProps = Omit<ComponentPropsWithoutRef<typeof Animated.View>, 'style'> & {
	isLoading: boolean
}

const duration = 1000

const Skeleton = ({ isLoading = true, className, children, ...props }: SkeletonProps) => {
	const sv = useSharedValue(1)

	useEffect(() => {
		sv.value = withRepeat(
			withSequence(withTiming(0.2, { duration }), withTiming(0.6, { duration })),
			-1
		)
	}, [sv])

	const style = useAnimatedStyle(() => ({
		opacity: sv.value,
	}))

	return isLoading ? (
		<Animated.View
			style={style}
			className={cn('rounded-md bg-palette_5', className)}
			{...props}
		/>
	) : (
		<>{children}</>
	)
}

export { Skeleton }
